import React, { lazy } from 'react';
interface Testimonial {
  quote: string;
  name: string;
  location: string;
  duration: string;
  initials: string;
  image: string;
  imageAlt: string;
}
const testimonials: Testimonial[] = [{
  quote: "By week three the mid-afternoon bloat had basically stopped. I'd had it every single day for four years. I didn't believe it at first — I kept waiting for it to come back. Week six I reintroduced oats, which I'd cut out eighteen months ago. No reaction. I cried in the kitchen.",
  name: 'Sarah M.',
  location: 'Bristol, UK',
  duration: 'used Nerva™ for 8 weeks',
  initials: 'SM',
  image: 'https://cdn.magicpatterns.com/uploads/n4jRZUnxUyJTk9V7dR1mT3/hf_20260522_093721_9d4cb910-46a9-4843-803b-39cbf542e9c1.png',
  imageAlt: 'Portrait of Sarah, a woman in her early forties holding a ceramic mug in a sunlit kitchen'
}, {
  quote: "I'd done three rounds of Rifaximin in two years. Every time it came back within a month or two. I was on a fourteen-food elimination diet and still cramping. Two months in with Nerva I'm eating things I hadn't touched since 2021. The urgency — the thing that ruled my life — is about 80% better. I'm not cured. But I feel like my body is actually trying to work again.",
  name: 'James T.',
  location: 'Melbourne, AU',
  duration: 'used Nerva™ for 9 weeks',
  initials: 'JT',
  image: 'https://cdn.magicpatterns.com/uploads/oEhDS6UWTRGLUoLGtNaCQR/hf_20260522_093729_d0e633cf-939a-4393-bb7e-9283a0374327.png',
  imageAlt: 'Portrait of James, a man in his late thirties wearing a grey t-shirt, standing on a leafy path in golden afternoon light'
}, {
  quote: "I have long COVID gut issues — started about three weeks after my infection in 2022 and nothing explained it and nothing touched it. My GI doctor was stumped. Six weeks with Nerva and my bowel regularity is back to something close to normal for the first time in three years. Sleep is better too. I don't know how to explain it except that something upstream shifted.",
  name: 'Diane K.',
  location: 'Toronto, CA',
  duration: 'used Nerva™ for 6 weeks',
  initials: 'DK',
  image: 'https://cdn.magicpatterns.com/uploads/v6NZEKG4ZpesMVmt2Y1f1r/hf_20260522_093734_ae5a299d-841d-4d10-820d-fb2dc3dae811.png',
  imageAlt: 'Portrait of Diane, a woman in her early fifties with silver hair, seated by a window beside a wall of books'
}];
export function Testimonials() {
  return <div className="my-12 space-y-8" data-id="element-228">
      {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-2xl shadow-sm border border-taupe/20 overflow-hidden grid grid-cols-1 sm:grid-cols-[200px_1fr]" data-id="element-229">
          <div className="hidden sm:block bg-beige/30" data-id="element-230">
            <img src={t.image} alt={t.imageAlt} className="w-full h-full object-cover aspect-square sm:aspect-auto" loading="lazy" data-id="element-231" />
          </div>
          <div className="sm:hidden" data-id="element-232">
            <img src={t.image} alt={t.imageAlt} className="w-full h-56 object-cover object-center" loading="lazy" data-id="element-233" />
          </div>
          <div className="p-6 sm:p-8 flex flex-col justify-center" data-id="element-234">
            <blockquote className="text-lg sm:text-xl font-serif italic text-forest leading-relaxed mb-6" data-id="element-235">
              "{t.quote}"
            </blockquote>
            <div className="flex items-center gap-3 pt-4 border-t border-taupe/20" data-id="element-236">
              <div data-id="element-237">
                <div className="font-medium text-ink" data-id="element-238">
                  {t.name}
                  <span className="text-ink/40 font-normal mx-1.5" data-id="element-239">·</span>
                  <span className="text-ink/60 font-normal" data-id="element-240">{t.location}</span>
                </div>
                <div className="text-xs text-sage uppercase tracking-wider mt-1" data-id="element-241">
                  {t.duration}
                </div>
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}